import React from 'react';

export default function ScheduleGridOverlayItem({
	overlayKey,
	rowStart = null,
	rowEnd = null,
	colStart = 1,
	colEnd = -1,
	className = '',
	innerClassName = '',
	content = null,
	style = {},
	...rest
}) {
	if(!rowStart || !rowEnd) return null;

	return (
		<div
			className={`mb-elem-grid-overlay ${className}`.trim()}
			style={{ gridColumnStart:colStart, gridColumnEnd:colEnd, gridRowStart:rowStart, gridRowEnd:rowEnd, ...style }}
			key={overlayKey}
			{...rest}
		>
			<div className={`mb-elem-grid-overlay-inner ${innerClassName}`.trim()}>
				{content}
			</div>
		</div>
	);
}
